 
import actiontypes from "../actions/actiontypes";
import { put, takeLatest } from "redux-saga/effects"
import { setLoginError, setTranslatableErrorMessage } from "../actions/loginactioncreators";
import { defineMessage } from "react-intl";


export const unknownErrorException = defineMessage({
    id: "unknownErrorException",
    defaultMessage: "Oops! Something went wrong. An unexpected error occurred. Please refresh the page or try again later.",
    description: "Error message for the login page"
});

const errorMap = {
  "Missing required parameter PASSWORD": defineMessage({
    id: "NotAuthorizedException", 
    defaultMessage:"User does not exist or could not be authenticated",
    description: "Error message for the login page"
  }),
  "Network error": unknownErrorException,
  "Invalid code received for user": defineMessage({
    id: "codeMismatchException",
    defaultMessage: "Invalid authorization code.",
    description: "Error message for the login page"
  }),
  "Missing required parameter SOFTWARE_TOKEN_MFA_CODE": defineMessage({
    id: "codeMismatchException",
    defaultMessage: "Invalid authorization code.",
    description: "Error message for the login page"
  }),
  "Invalid code or auth state for the user.": defineMessage({
    id: "codeMismatchException",
    defaultMessage: "Invalid authorization code.",
    description: "Error message for the login page"
  }),
  "Your software token has already been used once.": defineMessage({
    id: "codeMismatchException",
    defaultMessage: "Invalid authorization code.",
    description: "Error message for the login page"
  }),
  unknownErrorException: unknownErrorException,
  // Password-specific errors
  "Incorrect username or password.": defineMessage({
    id: "NotAuthorizedException",
    defaultMessage: "User does not exist or could not be authenticated",
    description: "Error message for the login page"
  }),
  "PreAuthentication failed with error Incorrect username or password..": defineMessage({
    id: "NotAuthorizedException",
    defaultMessage: "User does not exist or could not be authenticated",
    description: "Error message for the login page"
  }), // This error happens when a pre-authentication lambda triggers an error because of account number.
  "Password attempts exceeded": defineMessage({
    id: "tooManyFailedAttemptsException",
    defaultMessage: "Your account has been temporarily locked due to multiple invalid login attempts, and may take up to 15 minutes to automatically unlock",
    description: "Error message for the login page"
  }),
}

const triggerReload = {
  "Invalid session for the user, session is expired.": defineMessage({
    id: "codeMismatchException",
    defaultMessage: "Invalid authorization code.",
    description: "Error message for the login page"
  }), // This error happens when an MFA session has expired and there is no recourse except to login again.
  "Invalid session for the user.": defineMessage({
    id: "codeMismatchException",
    defaultMessage: "Invalid authorization code.",
    description: "Error message for the login page"
  }), // This error happens when an MFA session has expired and there is no recourse except to login again.
}

export function* handleError(action) {
  const error = action.payload;
  try {
     if (triggerReload[error.message]) {
      yield put(setTranslatableErrorMessage(triggerReload[error.message]));
      // Tell the browser to reload the page from cache
      setTimeout(() => {
        window.location.reload(true);
      }, 4000);
    } else if (error.response && error.response.data && error.response.data.reasonMessage) {
      // Legacy error handling, translated errors should be returned
      yield put(setLoginError(error.response.data.reasonMessage));
    } else if (errorMap[error.message]) {
      yield put(setTranslatableErrorMessage(errorMap[error.message]));
    } else {
      console.error("Unknown Error Encountered");
      console.error(error);
      yield put(setTranslatableErrorMessage(errorMap.unknownErrorException));
      // TODO may be a good idea to collect these in Google analytics or elsewhere 
    }
  } catch (e) {
    console.error("Unexpected error in handleError");
    console.error(e);
  }
}

export function* handleErrorWatcher() {
  yield takeLatest(actiontypes.HANDLE_ERROR, handleError);
}